import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiGrid-grid-xs-8':{
      marginBottom:'10px'
    }
  },
  headLine: {
    fontWeight: 'bold',
    fontSize: 14,
    listStyle: 'none',
    color: '#006cfc',
    marginBottom: theme.spacing(1),
  },
  usageItem: {
    fontSize: 12,
    fontWeight: 'normal',
    listStyle: 'none',
    marginBottom: 5,
    marginInlineStart: theme.spacing(1),
    position: 'relative',
    paddingInlineStart: theme.spacing(1.5),
    '&::before': {
      content: `" "`,
      position: 'absolute',
      left: 0,
      top: 6,
      width: 5,
      height: 5,
      borderRadius: 4,
    },
  },
  listHeadLine: {
    fontWeight: 'bold',
    fontSize: 12,
    listStyle: 'none',
    marginTop: theme.spacing(1.5),
    marginBottom: 5,
    paddingInlineStart: theme.spacing(0),
    '& span': {
      position: 'relative',
      top: 7,
      marginRight: 5,
      width:20,
      display:'inline-block',
    }
  },
  listHeadLineIcon: {
    fontSize: 15,
    marginInlineEnd: 5,
    marginBottom: -4,
  },
}));